<script>
export default {
  name: 'BaseInput',
}
</script>

<template>
  <el-input class="tamara-base-input" v-bind="$attrs" v-on="$listeners">
    <template v-slot:prefix>
      <slot name="prefix" />
    </template>
    <template v-slot:suffix>
      <slot name="suffix" />
    </template>
  </el-input>
</template>

<style lang="scss" scoped>
@import '@/styles/lavender/design.scss';

.tamara-base-input {
  &::v-deep {
    &.is-disabled {
      .el-input__inner {
        background-color: var(--tamara-color-functional-grey-light);
        opacity: 0.7;
      }
    }

    .el-input__inner {
      height: 48px;
      padding: var(--tamara-spacing-sm) var(--tamara-spacing-md);
      color: #212442;
      border: 1px solid var(--tamara-color-functional-grey-light);
      border-radius: var(--tamara-border-radius-md);

      @extend .tamara-body-large;
    }
  }
}
</style>
